import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const useNavigationTracker = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Inicializar el historial si no existe
    if (!sessionStorage.getItem('routeHistory')) {
      sessionStorage.setItem('routeHistory', JSON.stringify([window.location.pathname]));
    }

    // Guardar la ruta actual al cargar/recargar la página
    const currentPath = window.location.pathname;
    // console.log({currentPath})
    let historyList = JSON.parse(sessionStorage.getItem('routeHistory') || '[]');
    if (currentPath === '/') {
      historyList = [];
    }
    // const history = JSON.parse(sessionStorage.getItem('routeHistory') || '[]');

    if (historyList[historyList.length - 1] !== currentPath) {
      historyList.push(currentPath);
      sessionStorage.setItem('routeHistory', JSON.stringify(historyList));
    }

    // Manejar navegación hacia atrás/adelante
    const handlePopState = (event) => {
      const history = JSON.parse(sessionStorage.getItem('routeHistory') || '[]');
      console.log(history, window.location.pathname)
      const currentIndex = history.indexOf(window.location.pathname);
      // console.log({currentIndex})

      if (currentIndex > 0) {
        // Actualizar historial removiendo la ruta actual
        history.pop();
        const previous = history[history.length - 1];
        sessionStorage.setItem('routeHistory', JSON.stringify(history));

        // Navegar a la ruta anterior en nuestro historial
        navigate(previous, { replace: true });

        // // Navegar a la ruta anterior en nuestro historial
        // const prevRoute = history[currentIndex];
        // navigate(prevRoute);

        // // Actualizar historial removiendo la ruta actual
        // history.splice(currentIndex - 1, 1);
        // console.log({history})
        // sessionStorage.setItem('routeHistory', JSON.stringify(history));
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return null;
};

export default useNavigationTracker;
